import React from "react";
import arrow from "../../assets/arrow-orange.png";

import idea from "../../assets/idea.png";
import notebook from "../../assets/notebook.png";
import money from "../../assets/money-bag.png";
import socialMedia from "../../assets/social-media.png";

const teamItems = [
  {
    title: "Digital Soft Skills Development",
    description:
      "Training in key soft skills such as communi- cation, time management, and project management, which are crucial for freelancing success.",
    iconSrc: idea,
    arrowSrc: arrow,
    number: "01",
  },
  {
    title: "Freelancing Skills Workshops",
    description:
      "Hands-on workshops develop key freelancing skills through practical training. Personalized career coaching guides professionals in setting and achieving goals, with tailored support for career growth",
    iconSrc: money,
    arrowSrc: arrow,
    number: "02",
  },
  {
    title: "Custom Training Solutions",
    description:
      "Tailored training programs designed to meet the specific needs of businesses and individuals, ensuring relevant and effective skill development.",
    iconSrc: socialMedia,
    arrowSrc: arrow,
    number: "03",
  },
  {
    title: "Carrer couching and Mentoring",
    description:
      "Personalized guidance and support to help individuals navigate their freelancing careers, set goals, and achieve their professional aspirations.",
    iconSrc: notebook,
    arrowSrc: arrow,
    number: "04",
  },
];

const WorkSection = () => {
  return (
    <div className="container mx-auto px-4 py-[100px]">
      <div className="mx-auto mb-[70px] text-center xl:mb-[100px]">
        <h2 className="font-exo text-title sm2:text-[26px] text-[24px] font-bold uppercase leading-snug sm:text-[28px] lg:text-[32px] xl:text-[36px] 2xl:text-[40px]">
          Career Skills Mastery
        </h2>
      </div>
      <div className="flex flex-wrap justify-center">
        {teamItems.map((item, index) => (
          <div
            key={index}
            className="relative mb-5 flex flex-col items-center px-[15px] text-center md:w-[50%] lg:mb-0 lg:w-[25%] lg:even:mt-[60px]"
          >
            {index < teamItems.length - 1 && (
              <div className="absolute -right-[53px] top-[0] hidden lg:block">
                <img
                  src={item.arrowSrc}
                  alt="arrow"
                  className="custom-1400:me-0 custom-1300:me-2 lg:me-3 lg:h-[55px] lg:w-[85px] custom-1200:me-2.5 custom-1200:h-full custom-1200:w-full"
                  style={{
                    transform:
                      index % 2 === 0 ? "rotateX(0)" : "rotateX(180deg)",
                    opacity: 0.2,
                  }}
                />
              </div>
            )}
            <div className="shadow-shadow6 relative mb-7 flex h-[100px] w-[100px] items-center justify-center rounded-full bg-white lg:h-[130px] lg:w-[130px]">
              <img src={item.iconSrc} alt="icon" className="h-auto w-[45%]" />
              <span className="font-exo absolute right-0 top-0 flex h-[35px] w-[35px] items-center justify-center rounded-full border-[5px] border-white bg-custom-orange text-xs font-bold text-white">
                {item.number}
              </span>
            </div>
            <h3 className="font-exo text-title mb-2 text-lg font-bold leading-tight md:text-[20px]">
              {item.title}
            </h3>
            <p className="text-body max-w-[340px] text-sm leading-snug text-custom-light-black md:text-[14px]">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkSection;
